import { t } from "../../../../../utils/i18n";
import { FieldProps } from "formik";
import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

const DateTimeField: React.FC<FieldProps> = ({ field, form }) => (
  <DatePicker
    className={`form-control ${form.errors[field.name] ? "is-invalid" : ""}`}
    dateFormat="dd-MM-yyyy"
    peekNextMonth
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    isClearable={true}
    todayButton={t("cards.request_form.today_button")}
    utc={true}
    placeholderText={t("cards.request_form.click_to_select_a_date")}
    placeholder={t("cards.request_form.click_to_select_a_date")}
    selected={field.value}
    onChange={(date) => {
      form.setFieldValue(field.name, date);
    }}
  />
);

export default DateTimeField;
